(function() {

    angular
    .module('ngmvac')
    .directive('specialBannerImg', SpecialBannerImg);

    function SpecialBannerImg() {
        return {
            link: function (scope, element, attrs) {
                element.on('load', function () {
                    element.parent().css({display: 'block'});
                });
            }
        };
    }

})();